import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [expanded, setExpanded] = useState(false);

    const handleNavItemClick = () => {
        setExpanded(false);
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/" onClick={handleNavItemClick}><b>Professor (Dr) R.K.Sharma <br />
                        Nephrologist </b></Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded={expanded ? "true" : "false"}
                        aria-label="Toggle navigation"
                        onClick={() => setExpanded(!expanded)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`} id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to="/" onClick={handleNavItemClick}>Home</Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/About" onClick={handleNavItemClick}>About </Link>
                            </li>



                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to="#"
                                    id="appointmentDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded={expanded ? "true" : "false"}
                                >
                                    Facilities
                                </Link>
                                <ul className="dropdown-menu" aria-labelledby="appointmentDropdown">
                                    <li><Link className="dropdown-item" to="/" onClick={handleNavItemClick}> Facilities</Link></li>
                                    <li><Link className="dropdown-item" to="/" onClick={handleNavItemClick}> Cutting-edge Diagnostic</Link></li>
                                    <li><Link className="dropdown-item" to="/" onClick={handleNavItemClick}>  Modern Dialysis Units</Link></li>
                                    <li><Link className="dropdown-item" to="/" onClick={handleNavItemClick}> State-of-the-Art Operating Rooms</Link></li>
                                    <li><Link className="dropdown-item" to="/" onClick={handleNavItemClick}> Specialized Nephrology Intensive Care Units</Link></li>
                                </ul>
                            </li>


                            
                            
                           
                            
                            


                            <li className="nav-item">
                                <Link className="nav-link" to="/Gallery" onClick={handleNavItemClick}>Gallery</Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/Appointment" onClick={handleNavItemClick}>Appointment </Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
